import { Button } from '@material-ui/core';
import { default as ModuleContext } from 'CMFW/context/ModuleContext';
import { ModalWrapper } from 'components/ModalWrapper';
import PanelsModel from 'models/PanelsModel';
import React, { useContext, useState } from 'react';
import styled from 'styled-components';
import CourseSelect from '../../../components/selects/CourseSelect';
import MaterialUICheckbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import ListIdsBlind from '../../../components/common/ListIdsBlind';
import { IRefIds } from '../../../constants/refs';

type IProps = {
  onClose: () => void;
};

const PanelCopyModal: React.FC<IProps> = (props) => {
  const moduleModel = useContext(ModuleContext) as PanelsModel;
  const [copySentences, setCopySentences] = useState(true);
  const [isCoping, setIsCopying] = useState(false);
  const [selectCourseId, setSelectCourseId] = useState(0);
  const [newPanelId, setNewPanelId] = useState(null as number | null);

  const handleChangeCopySentence = (event: React.ChangeEvent<HTMLInputElement>, value: boolean) => {
    setCopySentences(value);
  };

  const handleChangeSelectCourseId = (courseId: number) => {
    setSelectCourseId(courseId);
  };

  const handleCopyClick = async () => {
    setIsCopying(true);
    const response = await moduleModel.copy(selectCourseId, copySentences);
    if (response.data) {
      setNewPanelId(response.data.id);
    }
  };

  return (
    <ModalWrapper title="Copy Panel" width={400} height={200} onClose={props.onClose}>
      <Scroll>
        <CourseSelectStyled onChange={handleChangeSelectCourseId} skipCourseId={moduleModel.courseId} />
        <FormControlLabelStyled
          control={<MaterialUICheckbox checked={copySentences} onChange={handleChangeCopySentence} color="primary" />}
          label={'Copy Sentences'}
        />
        {newPanelId !== null && (
          <ListIdsBlind
            courseId={selectCourseId}
            refId={IRefIds.panels}
            ids={[newPanelId]}
            label={'Panel:'}
            onClick={props.onClose}
          />
        )}
      </Scroll>
      <Footer>
        <Button
          variant="contained"
          size="small"
          disabled={isCoping || selectCourseId === 0}
          color="primary"
          onClick={handleCopyClick}
        >
          copy
        </Button>
      </Footer>
    </ModalWrapper>
  );
};

const CourseSelectStyled = styled(CourseSelect)`
  && {
    margin-top: 10px;
  }
`;

const FormControlLabelStyled = styled(FormControlLabel)`
  && {
    margin-top: 10px;
  }
`;

const Scroll = styled.div`
  flex-grow: 1;
  overflow: auto;
  padding-bottom: 10px;
  padding-right: 10px;
`;

const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-top: 4px;
`;

export default PanelCopyModal;
